/**
 * Types of banners that may be displayed if
 * showInformationBanner === True
 */
export enum BannerStatus {
  INCIDENT = 'INCIDENT',
  RESOLVED = 'RESOLVED',
  INFO = 'INFO',
}

export type AppBannerConfig = {
  message: string
  status: BannerStatus
}

export type ProductWarningConfig = {
  icon: string
  message?: string
  styles: string
}
